import AutomobileModifications from './presentation/AutomobileModifications'
import AutomobileTrace from './presentation/AutomobileTrace'
import DataView from './presentation/DataView'
import LaborSocialStandard from './presentation/LaborSocialStandard'
import MaterialDetails from './presentation/MaterialDetails'
import ModificationView from './presentation/ModificationView'
import PartDetails from './presentation/PartDetails'
import RepairInstruction from './presentation/RepairInstruction'
import VehicleTraceability from './presentation/VehicleTraceability'
import { hubFrontWheel } from '../../utils/icons'

const tabKeys = {
  autoMobile: 'autoMobile',
  parts: 'parts',
  materials: 'materials',
  data: 'data',
  traceOverview: 'traceOverview',
  ghgEmissions: 'ghgEmissions',
  laborSocial: 'laborSocial',
  repairInstructions: 'repairInstructions',
  modifications: 'modifications',
  vehicleTraceability: 'vehicleTraceability',
  processLoss: 'processLoss',
}

const {
  autoMobile,
  parts,
  materials,
  data,
  traceOverview,
  ghgEmissions,
  laborSocial,
  repairInstructions,
  modifications,
  vehicleTraceability,
  processLoss,
} = tabKeys

const vehicleTabList = [
  {
    label: 'vhc_Automobile',
    key: autoMobile,
    subType: [
      {
        label: 'vhc_Automobile',
        key: autoMobile,
      },
      {
        label: 'vhc_MaterialsPlaceOfOrigin',
        key: materials,
      },
      {
        label: 'vhc_MaterialTraceSequence',
        key: data,
      },
      {
        label: 'vhc_CarbonFootprint',
        key: ghgEmissions,
      },
      {
        label: 'vhc_ESGReporting',
        key: traceOverview,
        Component: AutomobileTrace,
      },
      {
        label: 'vhc_LaborAndSocialStandards',
        key: laborSocial,
        Component: LaborSocialStandard,
      },
      {
        label: 'vhc_RepairInstructions',
        key: repairInstructions,
        Component: RepairInstruction,
      },
      {
        label: 'vhc_Modifications',
        key: modifications,
        Component: AutomobileModifications,
      },
    ],
  },
  {
    label: 'vhc_Parts',
    key: parts,
    subType: [
      {
        label: 'vhc_Parts',
        key: parts,
        Component: PartDetails,
      },
      {
        label: 'vhc_MaterialsPlaceOfOrigin',
        key: materials,
        Component: MaterialDetails,
      },
      {
        label: 'vhc_MaterialTraceSequence',
        key: data,
        Component: DataView,
      },
      {
        label: 'vhc_CarbonFootprint',
        key: ghgEmissions,
      },
      {
        label: 'vhc_ESGReporting',
        key: traceOverview,
        Component: AutomobileTrace,
      },
      {
        label: 'vhc_LaborAndSocialStandards',
        key: laborSocial,
        Component: LaborSocialStandard,
      },
      {
        label: 'vhc_RepairInstructions',
        key: repairInstructions,
        Component: RepairInstruction,
      },
      {
        label: 'vhc_Modifications',
        key: modifications,
        Component: ModificationView,
      },
    ],
  },
  {
    label: 'vhc_VehicleTraceability',
    key: vehicleTraceability,
    Component: VehicleTraceability,
    subType: [
      {
        label: 'vhc_VehicleTraceability',
        key: vehicleTraceability,
        Component: VehicleTraceability,
      },
    ],
  },
  {
    label: 'inv_ProcessLoss',
    key: processLoss,
    Component: VehicleTraceability,
    subType: [
      {
        label: 'inv_ProcessLoss',
        key: processLoss,
        Component: VehicleTraceability,
      },
    ],
  },
]

//change parts key as api response key, ex: body --> bodyInfo
const vehicleParts = {
  body: 'body',
  tyre: 'tyre',
  windshield: 'windshield',
  airConditioner: 'airConditioner',
  battery: 'battery',
  batteryEV: 'batteryEV',
  engine: 'engine',
  liquids: 'liquids',
  doors: 'doors',
  doorParts: 'doorParts',
  bonnet: 'bonnet',
  fender: 'fender',
  bumper: 'bumper',
  frontBumper: 'frontBumper',
  backBumper: 'backBumper',
  headLight: 'headLight',
  tailLight: 'tailLight',
  seats: 'seats',
  steering: 'steering',
  dashboard: 'dashboard',
  floorMat: 'floorMat',
  rooflining: 'rooflining',
  wiringHarness: 'wiringHarness',
  FRSuspension: 'FRSuspension',
  glasses: 'glasses',
  trims: 'trims',
  plasticFastners: 'plasticFastners',
  hubFrontWheel: 'hubFrontWheel',
  drumBrake: 'drumBrake',
  insulatorSubAssyEngineMountLH: 'insulatorSubAssyEngineMountLH',
  bracketFRDoorBeamFR: 'bracketFRDoorBeamFR',
  flangeEGRPipe: 'flangeEGRPipe',
  plateRadiatorSupport: 'plateRadiatorSupport',
  bracketWiringHarnessClamp: 'bracketWiringHarnessClamp',
  holderFuelPressureSensor: 'holderFuelPressureSensor',
  lockSpareWheel: 'lockSpareWheel',
  lidFuelFillerOpeningInner: 'lidFuelFillerOpeningInner',
  innerMidBracket: 'innerMidBracket',
  pedalBracket: 'pedalBracket',
}

const vehicleSideBar = [
  {
    key: vehicleParts.doorParts,
    label: 'job_DoorParts',
    partTypeKey: 'Door Parts',
  },
  {
    key: vehicleParts.hubFrontWheel,
    label: 'inv_HubFrontWheel',
  },
  // {
  //   key: vehicleParts.bumper,
  //   label: 'inv_Bumper',
  // },
  {
    key: vehicleParts.frontBumper,
    label: 'job_FrontBumper',
  },
  {
    key: vehicleParts.backBumper,
    label: 'job_BackBumper',
  },
  {
    key: vehicleParts.drumBrake,
    label: 'inv_DrumBrake',
  },
  {
    key: vehicleParts.insulatorSubAssyEngineMountLH,
    label: 'job_InsulatorSubAssyEngineMountLH',
  },
  {
    key: vehicleParts.bracketFRDoorBeamFR,
    label: 'job_BracketFRDoorBeamFR',
  },
  {
    key: vehicleParts.flangeEGRPipe,
    label: 'job_FlangeEGRPipe',
  },
  {
    key: vehicleParts.plateRadiatorSupport,
    label: 'job_PlateRadiatorSupport',
  },
  {
    key: vehicleParts.bracketWiringHarnessClamp,
    label: 'job_BracketWiringHarnessClamp',
  },
  {
    key: vehicleParts.holderFuelPressureSensor,
    label: 'job_HolderFuelPressureSensor',
  },
  {
    key: vehicleParts.lockSpareWheel,
    label: 'job_LockSpareWheel',
  },
  {
    key: vehicleParts.lidFuelFillerOpeningInner,
    label: 'job_LidFuelFillerOpeningInner',
  },
  {
    key: vehicleParts.innerMidBracket,
    label: 'job_InnerMidBracket',
  },
  {
    key: vehicleParts.pedalBracket,
    label: 'job_PedalBracket',
  },
  {
    key: vehicleParts.batteryEV,
    label: 'job_BatteryEV',
  },
  {
    key: vehicleParts.battery,
    label: 'job_BatteryLeadAcid',
  },
  {
    key: vehicleParts.body,
    label: 'inv_Body',
  },
  {
    key: vehicleParts.engine,
    label: 'job_Engine',
  },
  {
    key: vehicleParts.windshield,
    label: 'inv_Windshield',
  },

  {
    key: vehicleParts.tyre,
    label: 'job_Tyre',
  },
  {
    key: vehicleParts.airConditioner,
    label: 'inv_AirConditioner',
  },
  {
    key: vehicleParts.liquids,
    label: 'inv_Liquids',
  },
  {
    key: vehicleParts.doors,
    label: 'job_Doors',
  },
  {
    key: vehicleParts.bonnet,
    label: 'job_Bonnet',
  },
  {
    key: vehicleParts.fender,
    label: 'job_Fenders',
  },
  {
    key: vehicleParts.headLight,
    label: 'job_HeadLights',
  },
  {
    key: vehicleParts.tailLight,
    label: 'job_TailLights',
  },
  {
    key: vehicleParts.seats,
    label: 'job_Seats',
  },
  {
    key: vehicleParts.steering,
    label: 'job_Steering',
  },
  {
    key: vehicleParts.dashboard,
    label: 'job_Dashboard',
  },
  {
    key: vehicleParts.floorMat,
    label: 'job_FloorMat',
  },
  {
    key: vehicleParts.rooflining,
    label: 'job_Rooflining',
  },
  {
    key: vehicleParts.wiringHarness,
    label: 'job_WiringHarness',
  },
  {
    key: vehicleParts.FRSuspension,
    label: 'job_FrontRearSuspension',
  },
  {
    key: vehicleParts.glasses,
    label: 'job_Glasses',
  },
  {
    key: vehicleParts.trims,
    label: 'job_Trims',
  },
  {
    key: vehicleParts.plasticFastners,
    label: 'job_PlasticFastners',
  },
]

const countryFlagImages = {
  India:
    'https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png',
  Japan:
    'https://i.pinimg.com/736x/f5/a1/5f/f5a15fdaada61d5fe673b7cc2e96f30d.jpg',
  China:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Flag_of_the_People%27s_Republic_of_China.svg/255px-Flag_of_the_People%27s_Republic_of_China.svg.png',
  'South Korea':
    'https://cdn.iconscout.com/icon/free/png-256/free-south-korea-flag-3001607-2495918.png',
  DRC: 'https://cdn.britannica.com/94/7194-004-5FA84A72/Flag-Democratic-Republic-of-the-Congo.jpg',
}

const partDataDummy = loginUserId => {
  switch (loginUserId) {
    case 798:
      return {
        [vehicleParts.hubFrontWheel]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Part Producer (Tier 1)',
            imageUrl: hubFrontWheel,
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Part Producer (Tier 1)',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Virgin Iron Producer',
            producerCountry: 'India',
            refurbisher: 'Steel Manufacturer',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Scrapping Facility (RVSF-1)',
            materials: [
              {
                material: '',
                refurbisher: 'Steel Manufacturer',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Vehicle Manufacturer Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Virgin Iron Producer)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Virgin Iron Producer)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.drumBrake]: {
          ddpData: {
            id: '4f155e4c-20ghj-35f',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Munjal Kiriu Industries Pvt. Ltd.',
            imageUrl:
              'https://www.akebono-brake.com/english/product_technology/img/product/automotive/drum/ph05.png',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Munjal Kiriu Industries Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '180mm * 200mm * 10mm',
            weight: '25 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Munjal Kiriu Industries Pvt. Ltd.',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'inv_CastIron',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '25 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'inv_CastIron',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_CastIronBlock',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '98 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_PigIron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.body]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '5th May, 2024',
            updated: '9th May, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://www.researchgate.net/publication/228752138/figure/fig1/AS:362728393854976@1463492596378/Picture-of-car-body-parts-generally-spoken-of-as-the-body-in-white.png',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '2nd May, 2024',
            manufacturingLocation: 'Gurugram, Haryana, India',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1,200 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '300 kg',
              materialProvenance:
                '50.0 % Noida, Uttar Pradesh, India <br> 50.0 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '50.0 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '50.0 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.engine]: {
          ddpData: {
            id: '6p165e4d-30jk-898m',
            created: '25th March, 2024',
            updated: '9th April, 2024',
            initiatedBy: 'Shivam Autotech Limited',
            imageUrl:
              'https://plus.unsplash.com/premium_photo-1682141708282-3a4f7023e1bb?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2FyJTIwZW5naW5lfGVufDB8fDB8fHww',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th March, 2024',
            manufacturingLocation: 'Gurgaon, Haryana, India',
            supplier: 'Shivam Autotech Limited',
            supplierCountry: 'India',
            weight: '9 kg',
            refurbisher: 'Nippon Steel Corporation',
            refurbisherCountry: 'India',
            volume: '0.025 m³',
            dimensions: '1400mm x 600mm x 5mm (LxBxH)',
            productCategory: 'Automobile Engine',
            virginIronProducer: 'Kobe Steel Ltd',
            producerCountry: 'India',
            brakePower: '150 HP',
            torque: '300 Nm',
            thermalEfficiency: '30%',
            specialFuelConsumption: '0.08 kg/kWh',
            materials: [
              {
                material: 'job_Steel',
                refurbisher: 'Nippon Steel Corporation',
                refurbisherCountry: 'India',
                recycler: 'Toyotsu Recycle Corporation',
                recyclerCountry: 'India',
              },
              {
                material: 'Aluminium',
                refurbisher: 'Delhi Metal Recycling',
                refurbisherCountry: 'India',
                recycler: 'Maruti Suzuki Toyotsu India',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki ARENA',
                address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+ARENA/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
              },
              {
                serviceStation: 'Maruti Suzuki True Value',
                address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+True+Value/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
              },
            ],
            components: [
              {
                title: 'inv_EngineBlock',
                ddpData: {
                  id: '5t165e4c-40glk-125r',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Sona BLW Precision Forgings Ltd.',
                  imageUrl:
                    'https://www.wellfarengineparts.com/Content/uploads/2022874605/2022110714181831bcc6d5bb31404a8fa9d05a002ab897.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Sona BLW Precision Forgings Ltd.',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '25 * 30 inches',
                weight: '100 kg',
                tensileStrength: '250 MPa',
                thermalConductivity: '120 W/m·K',
                maxTemperature: '200°C',
                materials: [
                  {
                    material: 'Aluminium',
                    refurbisher: 'Jindal Aluminium Limited',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Maruti Suzuki Service Center',
                    address: '789, Vasant Kunj, Delhi-110070',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_CylinderHead',
                ddpData: {
                  id: '9g165e4c-40glk-365h',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Bharat Forge Ltd.',
                  imageUrl:
                    'https://www.shutterstock.com/image-photo/car-engine-cylinder-head-isolated-600nw-335068742.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Bharat Forge Ltd.',
                status: 'Original',
                manufacturer: 'Bharat Forge Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Pune, Maharashtra, India',
                productCategory: 'Automobile Engine',
                dimensions: '300 mm * 250 mm',
                airFlow: '250 CFM',
                compressionRatio: '10.5:1',
                valveLift: '12 mm',
                coolingEfficiency: '90%',
                virginProducer: 'Utkal Alumina International Limited (UAIL)',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'Aluminium',
                    refurbisher: 'Metline Industries',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gupta Automobiles',
                    address: 'Plot No. 150, Saini Mohalla, Bijwasan',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Gupta+Automobiles/data=!4m7!3m6!1s0x390d02ff60b0ad2d:0x342d2bc23d03cb15!8m2!3d28.662476!4d77.1524311!16s%2Fg%2F1x6q049t!19sChIJLa2wYP8CDTkRFcsDPcIrLTQ?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_Crankshaft',
                ddpData: {
                  id: '9pd65e4c-40glk-002r',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Cooper Corporation',
                  imageUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3Gmn33hTjvQGoMxhR-Qas_Bqom2HUE90mYz7F6rSRglCKUHafx4aKGMSD9LeemdCxXIc&usqp=CAU',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Cooper Corporation',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Pune, Maharashtra, India',
                productCategory: 'Automobile Engine',
                dimensions: '600mm * 80mm',
                weight: '30 kg',
                tensileStrength: '700 N/mm²',
                fatigueStrength: '300 N/mm²',
                hardness: '50-60 HRC',
                virginProducer: 'Aanchal Ispat Ltd.',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'job_Steel',
                    refurbisher: 'Vardhman Special Steels Ltd',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Gupta+Automobiles/data=!4m7!3m6!1s0x390d02ff60b0ad2d:0x342d2bc23d03cb15!8m2!3d28.662476!4d77.1524311!16s%2Fg%2F1x6q049t!19sChIJLa2wYP8CDTkRFcsDPcIrLTQ?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'GoMechanic Insta Car Care',
                    address: '23, Rama Rd, Moti Nagar, Delhi',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GoMechanic+-+Insta+Car+Care+Central,+Moti+Nagar/data=!4m7!3m6!1s0x390d02f6725d7601:0xcc0cd9a35e5a2ea5!8m2!3d28.6607474!4d77.1540872!16s%2Fg%2F11tfd8r192!19sChIJAXZdcvYCDTkRpS5aXqPZDMw?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventorySparkPlug',
                ddpData: {
                  id: '6f35e4c-34glk-312t',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'NGK Spark Plug India Pvt. Ltd.',
                  imageUrl: 'https://www.cbac.com/images/blog/blog-17.5.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'NGK Spark Plug India Pvt. Ltd.',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '18mm *10mm',
                heatRange: '5 (Hot) to 12 (Cold)',
                voltageRating: '45,000 volts',
                currentRating: '2.5 amps',
                serviceLife: '30,000 to 100,000 km',
                virginProducer: 'Aanchal Ispat Ltd.',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'Nickel',
                    refurbisher: 'Nidhi Impex',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_Bearings',
                ddpData: {
                  id: '31g65e4c-20adk-259f',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Bharat Bearings Ltd.',
                  imageUrl:
                    'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRQ7swBEUqRLmqbP1yzgobpmnuCbNTXbEkhtokM-7HWNyaMmN3l',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Bharat Bearings Ltd.',
                status: 'Original',
                manufacturer: 'Bharat Bearings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Faridabad, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '10mm * 20mm',
                loadCapacity: '5000 N',
                speedRating: '3000 RPM',
                operatingTemperature: '120°C',
                fatigueLife: '100,000 hours',
                materials: [
                  {
                    material: 'Nickel',
                    refurbisher: 'Sanjari Recycling',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventoryExhaustSystem',
                ddpData: {
                  id: '25f65ge4c-20jgf-34t',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Tenneco Automotive India Pvt. Ltd.',
                  imageUrl:
                    'https://www.walkerexhaust.com/content/loc-na/loc-us/fmmp-walker/en_US/support/exhaust-101/what-parts-make-up-the-exhaust-system/_jcr_content/article/article-par/fmmp_image_text_1768983451/image.img.png/Manifold-Car-Exhaust-System-Component-1684942894808.png',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Tenneco Automotive India Pvt. Ltd.',
                status: 'Original',
                manufacturer: 'Tenneco Automotive India Pvt. Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '1000mm * 30mm',
                backPressure: '20 kPa',
                noiseReduction: '25 dB',
                thermalEfficiency: '80%',
                durability: '100,000 km',
                materials: [
                  {
                    material: 'Plastic',
                    refurbisher: 'EcoWise',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventoryGasket',
                ddpData: {
                  id: '6ad5165e4c-20jhg-203d',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Fixer Gaskets',
                  imageUrl:
                    'https://accushapediecutting.com/wp-content/uploads/2021/12/accu4.webp',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Fixer Gaskets',
                status: 'Original',
                manufacturer: 'Fixer Gaskets',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Delhi, India',
                productCategory: 'Automobile Engine',
                dimensions: '10mm * 5mm *1mm',
                tensileStrength: '10 MPa',
                temperatureResistance: '-40°C to 150°C',
                pressureResistance: '10 bar',
                compressionSet: '25%',
                materials: [
                  {
                    material: 'Rubber',
                    refurbisher: 'CEAT Ltd',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
            ],
          },
          materialInfo: [
            {
              material: 'Aluminium',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '9 kg',
              materialProvenance:
                '50.0 % Noida, India <br> 50.0% Odisha, India',
            },
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '8 kg',
              materialProvenance:
                '50.0 % Noida, India <br> 50.0 % Hyderabad, India',
            },
            {
              material: 'Nickel',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '2 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Copper',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '1 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Plastic',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '3 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Rubber',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '7 kg',
              materialProvenance: '100.0 % Noida, India',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Aluminium',
              ratio: [
                {
                  subTitle: '50.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Aluminium Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine Block',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Odisha, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bauxite Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Alumina/Aluminium Oxide',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Pure Aluminium',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Aluminium Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cylinder Head',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Second Material Provenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '50.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Crankshaft',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Hyderabad, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Crankshaft',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Third Material Provenance',
              material: 'Nickel',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Nickel',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Spark Plug',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Fourth Material Provenance',
              material: 'Copper',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Copper',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bearings',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Fifth Material Provenance',
              material: 'Plastic',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Plastic',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Exhaust System',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Sixth Material Provenance',
              material: 'Rubber',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Rubber',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Gasket',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.windshield]: {
          ddpData: {
            id: '5q165e4d-29lk-787h',
            created: '26th January, 2024',
            updated: '9th March, 2024',
            initiatedBy: 'Fuyao Glass Industry Group Co., Ltd.',
            imageUrl:
              'https://miracleagc.com/wp-content/uploads/2022/06/windshield-repair-san-antonio-2-1024x683.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '26th January, 2024',
            manufacturingLocation: 'Fuzhou, Fujian, China',
            supplier: 'Fuyao Glass Industry',
            supplierCountry: 'China',
            weight: '8.5 kg',
            volume: '0.015 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            materials: [
              {
                material: '',
                refurbisher: 'Liaoning Glass Group Co. Ltd',
                refurbisherCountry: 'China',
                recycler: 'Shenzhen Huitongda Recycling Technology Co., Ltd.',
                recyclerCountry: 'China',
              },
            ],
          },
          materialInfo: [
            {
              material: 'Glass Cullet',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '35 kg',
              materialProvenance:
                '100 % Shenzhen, Guangdong, China (Shenzhen Huitongda Recycling Technology Co., Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Glass Cullet',
              ratio: [
                {
                  subTitle:
                    '100 % Shenzhen, Guangdong, China (Shenzhen Huitongda Recycling Technology Co., Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Glass Cullet (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Glass (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Laminated Glass',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Windshield',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.bumper]: {
          ddpData: {
            id: '7g165e4d-29lk-909i',
            created: '25th March, 2024',
            updated: '10th February, 2024',
            initiatedBy: 'Plastic Manufacturer',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt5a8r6ZCrQJkNFTTjYZm_2E71l8nRklkMGQ&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          materialInfo: [
            {
              material: 'job_Plastic',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (50 * 0.02 = 1)',
              physicalAmount: '50 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Amritsar, Punjab, India (Virgin plastic producer)',
            },
          ],
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th March, 2024',
            manufacturingLocation: 'France',
            supplier: 'Part Producer (Tier 1)',
            supplierCountry: 'India',
            weight: '9 kg',
            volume: '0.025 m³',
            dimensions: '1400mm x 600mm x 5mm (LxBxH)',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Virgin plastic producer',
            producerCountry: 'India',
            refurbisher: 'Plastic Manufacturer 1',
            refurbisher2: 'Plastic Manufacturer 2',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Scrapping Facility (RVSF-1)',
            materials: [
              {
                material: 'job_Steel',
                refurbisher: 'Steel Manufacturer',
                refurbisherCountry: 'India',
                recycler: 'Scrapping Facility (RVSF-1)',
                recyclerCountry: 'India',
              },
              {
                material: 'Plastic',
                refurbisher: 'Plastic Manufacturer',
                refurbisherCountry: 'India',
                recycler: 'Scrapping Facility (RVSF-1)',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Vehicle Manufacturer Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Plastic',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_PlasticPallets',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '98 % Amritsar, Punjab, India (Virgin plastic producer)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_CrudeOil',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_Cracking',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_Propane',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Propylene',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.tyre]: {
          ddpData: {
            id: '5q165e4d-29lk-787h',
            created: '26th January, 2024',
            updated: '9th March, 2024',
            initiatedBy: 'MRF (Madras Rubber Factory)',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeW1cXvFVomgSSSDaDMVjZ9skkZ733516UKA&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '26th January, 2024',
            manufacturingLocation: 'Hamamatsu, Japan',
            supplier: 'MRF (Madras Rubber Factory)',
            supplierCountry: 'India',
            weight: '8.5 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            materials: [
              {
                material: '',
                refurbisher: 'NEOTECH Rubber Products',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
          },
        },
        [vehicleParts.battery]: {
          ddpData: {
            id: '7z165e4d-29lk-897u',
            created: '25th December, 2023',
            updated: '9th January, 2024',
            initiatedBy: 'Exide Industries Ltd.',
            imageUrl:
              'https://media.istockphoto.com/id/1197345162/photo/dead-car-rusty-battery-recycling.jpg?s=612x612&w=0&k=20&c=3cA_4qKuT6gn4krZMUStBVcZDIw_HksC8eqzf-9jNbQ=',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th December, 2023',
            manufacturingLocation: 'Midnapore (E), West Bengal, India',
            supplier: 'Exide Industries Ltd.',
            supplierCountry: 'India',
            supplier1: 'Exide Cell Manufacturing Ltd.',
            supplierCountry1: 'India',
            weight: '50 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            chemistry: 'Lead Acid',
            batteryCell: 'Prismatic',
            noOfCell: 180,
            energyDensity: '0.1724 kWh/kg',
            totalEnergy: '100kWh',
            expectedLifetime: '5 years',
            ratedCapacity: '151 Ah',
            remainingLifetime: '5 years',
            virginLeadProducer: 'Beta Lead Ltd.',
            producerCountry: 'India',
            virginSulfuricProducer: 'Gamma Sulfur Ltd.',
            voltage: '450-662-742 V DC',
            tempRange: '-30°C to +60°C',
            materials: [
              {
                material: '',
                refurbisher: 'HBL Power Systems Ltd.',
                refurbisherCountry: 'India',
                recycler: 'Maruti Suzuki Toyotsu India',
                recyclerCountry: 'India',
              },
            ],
          },
          materialInfo: [
            {
              material: 'Metallic Lead (Pb)',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '35 kg',
              materialProvenance:
                '50.0 % Noida, Uttar Pradesh, India <br> 50.0 % Ludhiana, Punjab, India (Beta Lead Ltd.)',
            },
            {
              material: 'Sulfuric Acid',
              traceability: '100%',
              circularity: '0%',
              physicalAmount: '5 kg',
              materialProvenance: '100.0 % Jamnagar, Gujarat, India',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Metallic Lead (Pb)',
              ratio: [
                {
                  subTitle: '50.0 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead (Recycled)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode + (Lead Oxide)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode - (Metallic Lead)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Ludhiana, Punjab, India (Beta Lead Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Lead',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Metallic Lead',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode + (Lead Oxide)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode - (Metallic Lead)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Second Material Provenance',
              material: 'Sulfuric Acid',
              ratio: [
                {
                  subTitle: '100.0 % Jamnagar, Gujarat, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sulfide Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Sulfur',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sulfuric Acid',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.batteryEV]: {
          ddpData: {
            id: '7z165e4d-29lk-899u',
            created: '25th December, 2023',
            updated: '9th January, 2024',
            initiatedBy: 'Attero Recycling Pvt Ltd',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBlVRSSjxY_fMA3yoxULmPtbeOa9cF5keMXw&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            refurbisher: 'Attero Recycling Pvt Ltd',
            manufacturingDate: '25th December, 2023',
            manufacturingLocation: 'Midnapore (E), West Bengal, India',
            supplier: 'Amara Raja Batteries',
            supplierCountry: 'India',
            // supplier1: 'LG Energy Solution Ltd.',
            recycler: 'Maruti Suzuki Toyotsu India',
            supplierCountry1: 'China',
            weight: '418 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            chemistry: 'NCM-M50',
            batteryCell: 'Cylindrical',
            noOfCell: '4,416',
            energyDensity: '0.1622 kWh/kg',
            totalEnergy: '78.05 kWh',
            expectedLifetime: '1,200 cycles',
            ratedCapacity: '219 Ah',
            remainingLifetime: '1,195 cycles',
            virginCobaltProducer: 'KRAJ Enterprises',
            producerCountry: 'India',
            voltage: '357 V DC',
            tempRange: '-30°C to +60°C',
            materials: [
              {
                material: '',
                refurbisher: 'HBL Power Systems Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
          },
          materialInfo: [
            {
              material: 'inv_LithiumCarbonate',
              traceability: '100%',
              circularity: '0%',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
            {
              material: 'inv_Iron',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
            {
              material: 'inv_Phosphate',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'inv_LithiumCarbonate',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_BatteryEV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_BlackMass',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_LithiumCarbonateBattery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '98 % Mumbai, Maharashtra, India (KRAJ Enterprises)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Precursor',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'CAM',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
      }

    default:
      return {
        [vehicleParts.hubFrontWheel]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl: hubFrontWheel,
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.drumBrake]: {
          ddpData: {
            id: '4f155e4c-20ghj-35f',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Munjal Kiriu Industries Pvt. Ltd.',
            imageUrl:
              'https://www.akebono-brake.com/english/product_technology/img/product/automotive/drum/ph05.png',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Munjal Kiriu Industries Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '180mm * 200mm * 10mm',
            weight: '25 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Munjal Kiriu Industries Pvt. Ltd.',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'inv_CastIron',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '25 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'inv_CastIron',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_CastIronBlock',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '98 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_PigIron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_DrumBrake',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.body]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '5th May, 2024',
            updated: '9th May, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://www.researchgate.net/publication/228752138/figure/fig1/AS:362728393854976@1463492596378/Picture-of-car-body-parts-generally-spoken-of-as-the-body-in-white.png',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '2nd May, 2024',
            manufacturingLocation: 'Gurugram, Haryana, India',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1,200 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '300 kg',
              materialProvenance:
                '50.0 % Noida, Uttar Pradesh, India <br> 50.0 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '50.0 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '50.0 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.engine]: {
          ddpData: {
            id: '6p165e4d-30jk-898m',
            created: '25th March, 2024',
            updated: '9th April, 2024',
            initiatedBy: 'Shivam Autotech Limited',
            imageUrl:
              'https://plus.unsplash.com/premium_photo-1682141708282-3a4f7023e1bb?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2FyJTIwZW5naW5lfGVufDB8fDB8fHww',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th March, 2024',
            manufacturingLocation: 'Gurgaon, Haryana, India',
            supplier: 'Shivam Autotech Limited',
            supplierCountry: 'India',
            weight: '9 kg',
            refurbisher: 'Nippon Steel Corporation',
            refurbisherCountry: 'India',
            volume: '0.025 m³',
            dimensions: '1400mm x 600mm x 5mm (LxBxH)',
            productCategory: 'Automobile Engine',
            virginIronProducer: 'Kobe Steel Ltd',
            producerCountry: 'India',
            brakePower: '150 HP',
            torque: '300 Nm',
            thermalEfficiency: '30%',
            specialFuelConsumption: '0.08 kg/kWh',
            materials: [
              {
                material: 'job_Steel',
                refurbisher: 'Nippon Steel Corporation',
                refurbisherCountry: 'India',
                recycler: 'Toyotsu Recycle Corporation',
                recyclerCountry: 'India',
              },
              {
                material: 'Aluminium',
                refurbisher: 'Delhi Metal Recycling',
                refurbisherCountry: 'India',
                recycler: 'Maruti Suzuki Toyotsu India',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki ARENA',
                address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+ARENA/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
              },
              {
                serviceStation: 'Maruti Suzuki True Value',
                address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+True+Value/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
              },
            ],
            components: [
              {
                title: 'inv_EngineBlock',
                ddpData: {
                  id: '5t165e4c-40glk-125r',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Sona BLW Precision Forgings Ltd.',
                  imageUrl:
                    'https://www.wellfarengineparts.com/Content/uploads/2022874605/2022110714181831bcc6d5bb31404a8fa9d05a002ab897.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Sona BLW Precision Forgings Ltd.',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '25 * 30 inches',
                weight: '100 kg',
                tensileStrength: '250 MPa',
                thermalConductivity: '120 W/m·K',
                maxTemperature: '200°C',
                materials: [
                  {
                    material: 'Aluminium',
                    refurbisher: 'Jindal Aluminium Limited',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Maruti Suzuki Service Center',
                    address: '789, Vasant Kunj, Delhi-110070',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_CylinderHead',
                ddpData: {
                  id: '9g165e4c-40glk-365h',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Bharat Forge Ltd.',
                  imageUrl:
                    'https://www.shutterstock.com/image-photo/car-engine-cylinder-head-isolated-600nw-335068742.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Bharat Forge Ltd.',
                status: 'Original',
                manufacturer: 'Bharat Forge Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Pune, Maharashtra, India',
                productCategory: 'Automobile Engine',
                dimensions: '300 mm * 250 mm',
                airFlow: '250 CFM',
                compressionRatio: '10.5:1',
                valveLift: '12 mm',
                coolingEfficiency: '90%',
                virginProducer: 'Utkal Alumina International Limited (UAIL)',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'Aluminium',
                    refurbisher: 'Metline Industries',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gupta Automobiles',
                    address: 'Plot No. 150, Saini Mohalla, Bijwasan',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Gupta+Automobiles/data=!4m7!3m6!1s0x390d02ff60b0ad2d:0x342d2bc23d03cb15!8m2!3d28.662476!4d77.1524311!16s%2Fg%2F1x6q049t!19sChIJLa2wYP8CDTkRFcsDPcIrLTQ?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_Crankshaft',
                ddpData: {
                  id: '9pd65e4c-40glk-002r',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Cooper Corporation',
                  imageUrl:
                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3Gmn33hTjvQGoMxhR-Qas_Bqom2HUE90mYz7F6rSRglCKUHafx4aKGMSD9LeemdCxXIc&usqp=CAU',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Cooper Corporation',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Pune, Maharashtra, India',
                productCategory: 'Automobile Engine',
                dimensions: '600mm * 80mm',
                weight: '30 kg',
                tensileStrength: '700 N/mm²',
                fatigueStrength: '300 N/mm²',
                hardness: '50-60 HRC',
                virginProducer: 'Aanchal Ispat Ltd.',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'job_Steel',
                    refurbisher: 'Vardhman Special Steels Ltd',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Gupta+Automobiles/data=!4m7!3m6!1s0x390d02ff60b0ad2d:0x342d2bc23d03cb15!8m2!3d28.662476!4d77.1524311!16s%2Fg%2F1x6q049t!19sChIJLa2wYP8CDTkRFcsDPcIrLTQ?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'GoMechanic Insta Car Care',
                    address: '23, Rama Rd, Moti Nagar, Delhi',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GoMechanic+-+Insta+Car+Care+Central,+Moti+Nagar/data=!4m7!3m6!1s0x390d02f6725d7601:0xcc0cd9a35e5a2ea5!8m2!3d28.6607474!4d77.1540872!16s%2Fg%2F11tfd8r192!19sChIJAXZdcvYCDTkRpS5aXqPZDMw?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventorySparkPlug',
                ddpData: {
                  id: '6f35e4c-34glk-312t',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'NGK Spark Plug India Pvt. Ltd.',
                  imageUrl: 'https://www.cbac.com/images/blog/blog-17.5.jpg',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'NGK Spark Plug India Pvt. Ltd.',
                status: 'Original',
                manufacturer: 'Sona BLW Precision Forgings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '18mm *10mm',
                heatRange: '5 (Hot) to 12 (Cold)',
                voltageRating: '45,000 volts',
                currentRating: '2.5 amps',
                serviceLife: '30,000 to 100,000 km',
                virginProducer: 'Aanchal Ispat Ltd.',
                producerCountry: 'India',
                materials: [
                  {
                    material: 'Nickel',
                    refurbisher: 'Nidhi Impex',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_Bearings',
                ddpData: {
                  id: '31g65e4c-20adk-259f',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Bharat Bearings Ltd.',
                  imageUrl:
                    'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRQ7swBEUqRLmqbP1yzgobpmnuCbNTXbEkhtokM-7HWNyaMmN3l',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Bharat Bearings Ltd.',
                status: 'Original',
                manufacturer: 'Bharat Bearings Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Faridabad, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '10mm * 20mm',
                loadCapacity: '5000 N',
                speedRating: '3000 RPM',
                operatingTemperature: '120°C',
                fatigueLife: '100,000 hours',
                materials: [
                  {
                    material: 'Nickel',
                    refurbisher: 'Sanjari Recycling',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventoryExhaustSystem',
                ddpData: {
                  id: '25f65ge4c-20jgf-34t',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Tenneco Automotive India Pvt. Ltd.',
                  imageUrl:
                    'https://www.walkerexhaust.com/content/loc-na/loc-us/fmmp-walker/en_US/support/exhaust-101/what-parts-make-up-the-exhaust-system/_jcr_content/article/article-par/fmmp_image_text_1768983451/image.img.png/Manifold-Car-Exhaust-System-Component-1684942894808.png',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Tenneco Automotive India Pvt. Ltd.',
                status: 'Original',
                manufacturer: 'Tenneco Automotive India Pvt. Ltd.',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Gurgaon, Haryana, India',
                productCategory: 'Automobile Engine',
                dimensions: '1000mm * 30mm',
                backPressure: '20 kPa',
                noiseReduction: '25 dB',
                thermalEfficiency: '80%',
                durability: '100,000 km',
                materials: [
                  {
                    material: 'Plastic',
                    refurbisher: 'EcoWise',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
              {
                title: 'inv_GenericInventoryGasket',
                ddpData: {
                  id: '6ad5165e4c-20jhg-203d',
                  created: '5th May, 2024',
                  updated: '9th May, 2024',
                  initiatedBy: 'Fixer Gaskets',
                  imageUrl:
                    'https://accushapediecutting.com/wp-content/uploads/2021/12/accu4.webp',
                  qrCode:
                    'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
                },
                producerName: 'Fixer Gaskets',
                status: 'Original',
                manufacturer: 'Fixer Gaskets',
                manufacturingDate: '5th May, 2024',
                manufacturingLocation: 'Delhi, India',
                productCategory: 'Automobile Engine',
                dimensions: '10mm * 5mm *1mm',
                tensileStrength: '10 MPa',
                temperatureResistance: '-40°C to 150°C',
                pressureResistance: '10 bar',
                compressionSet: '25%',
                materials: [
                  {
                    material: 'Rubber',
                    refurbisher: 'CEAT Ltd',
                    refurbisherCountry: 'India',
                    recycler: 'Maruti Suzuki Toyotsu India',
                    recyclerCountry: 'India',
                  },
                ],
                collectionDataSource: [
                  {
                    serviceStation: 'ACR',
                    address: '123, Industrial Area, Delhi-110001',
                    googleMapsLink:
                      'https://www.google.com/maps/place/Auto+Car+Repair+%28ACR%29/data=!4m7!3m6!1s0x390d17df3e2c6c05:0xe71b41b0f86ca715!8m2!3d28.4315216!4d77.0123524!16s%2Fg%2F11s94l6wzc!19sChIJBWwsPt8XDTkRFads-LBBG-c?authuser=0&hl=en&rclk=1',
                  },
                  {
                    serviceStation: 'Gaurav Motors',
                    address: 'H. No - B-74, Bhagwati Garden Extn, Uttam Nagar',
                    googleMapsLink:
                      'https://www.google.com/maps/place/GAURAV+MOTORS/data=!4m7!3m6!1s0x390cfb1703b2bcd9:0xe16952a1793ddade!8m2!3d28.6582502!4d77.314367!16s%2Fg%2F12hpwwr2v!19sChIJ2byyAxf7DDkR3to9eaFSaeE?authuser=0&hl=en&rclk=1',
                  },
                ],
              },
            ],
          },
          materialInfo: [
            {
              material: 'Aluminium',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '9 kg',
              materialProvenance:
                '50.0 % Noida, India <br> 50.0% Odisha, India',
            },
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '8 kg',
              materialProvenance:
                '50.0 % Noida, India <br> 50.0 % Hyderabad, India',
            },
            {
              material: 'Nickel',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '2 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Copper',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '1 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Plastic',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '3 kg',
              materialProvenance: '100.0 % Noida, India',
            },
            {
              material: 'Rubber',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '7 kg',
              materialProvenance: '100.0 % Noida, India',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Aluminium',
              ratio: [
                {
                  subTitle: '50.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Aluminium Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine Block',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Odisha, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bauxite Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Alumina/Aluminium Oxide',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Pure Aluminium',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Aluminium Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cylinder Head',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Second Material Provenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '50.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Crankshaft',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Hyderabad, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Crankshaft',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Third Material Provenance',
              material: 'Nickel',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Nickel',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Spark Plug',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Fourth Material Provenance',
              material: 'Copper',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Copper',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bearings',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Fifth Material Provenance',
              material: 'Plastic',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Plastic',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Exhaust System',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Sixth Material Provenance',
              material: 'Rubber',
              ratio: [
                {
                  subTitle: '100.0 % Noida, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Rubber',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Gasket',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Engine',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.windshield]: {
          ddpData: {
            id: '5q165e4d-29lk-787h',
            created: '26th January, 2024',
            updated: '9th March, 2024',
            initiatedBy: 'Fuyao Glass Industry Group Co., Ltd.',
            imageUrl:
              'https://miracleagc.com/wp-content/uploads/2022/06/windshield-repair-san-antonio-2-1024x683.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '26th January, 2024',
            manufacturingLocation: 'Fuzhou, Fujian, China',
            supplier: 'Fuyao Glass Industry',
            supplierCountry: 'China',
            weight: '8.5 kg',
            volume: '0.015 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            materials: [
              {
                material: '',
                refurbisher: 'Liaoning Glass Group Co. Ltd',
                refurbisherCountry: 'China',
                recycler: 'Shenzhen Huitongda Recycling Technology Co., Ltd.',
                recyclerCountry: 'China',
              },
            ],
          },
          materialInfo: [
            {
              material: 'Glass Cullet',
              traceability: '100%',
              circularity: '100%',
              physicalAmount: '35 kg',
              materialProvenance:
                '100 % Shenzhen, Guangdong, China (Shenzhen Huitongda Recycling Technology Co., Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Glass Cullet',
              ratio: [
                {
                  subTitle:
                    '100 % Shenzhen, Guangdong, China (Shenzhen Huitongda Recycling Technology Co., Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Glass Cullet (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Glass (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Laminated Glass',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Windshield',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.bumper]: {
          ddpData: {
            id: '7g165e4d-29lk-909i',
            created: '25th March, 2024',
            updated: '10th February, 2024',
            initiatedBy: 'Bharat Forge Ltd.',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt5a8r6ZCrQJkNFTTjYZm_2E71l8nRklkMGQ&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          materialInfo: [
            {
              material: 'job_Plastic',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (50 * 0.02 = 1)',
              physicalAmount: '50 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th March, 2024',
            manufacturingLocation: 'France',
            supplier:
              'Advanced Industrial and Engineering Polymer Research (KingFa)',
            supplierCountry: 'India',
            weight: '9 kg',
            volume: '0.025 m³',
            dimensions: '1400mm x 600mm x 5mm (LxBxH)',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Vizag Chemicals',
            producerCountry: 'India',
            refurbisher: 'Peeco Plastics-Panipat',
            refurbisher2: 'Peeco Plastics-Sonipat',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: 'job_Steel',
                refurbisher: 'Vardhman Special Steels Ltd',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
              {
                material: 'Plastic',
                refurbisher: 'Recykal',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Plastic',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_PlasticPallets',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '98 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_CrudeOil',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_Cracking',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_Propane',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Propylene',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_Bumpers',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.tyre]: {
          ddpData: {
            id: '5q165e4d-29lk-787h',
            created: '26th January, 2024',
            updated: '9th March, 2024',
            initiatedBy: 'MRF (Madras Rubber Factory)',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeW1cXvFVomgSSSDaDMVjZ9skkZ733516UKA&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '26th January, 2024',
            manufacturingLocation: 'Hamamatsu, Japan',
            supplier: 'MRF (Madras Rubber Factory)',
            supplierCountry: 'India',
            weight: '8.5 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            materials: [
              {
                material: '',
                refurbisher: 'NEOTECH Rubber Products',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
          },
        },
        [vehicleParts.battery]: {
          ddpData: {
            id: '7z165e4d-29lk-897u',
            created: '25th December, 2023',
            updated: '9th January, 2024',
            initiatedBy: 'Exide Industries Ltd.',
            imageUrl:
              'https://media.istockphoto.com/id/1197345162/photo/dead-car-rusty-battery-recycling.jpg?s=612x612&w=0&k=20&c=3cA_4qKuT6gn4krZMUStBVcZDIw_HksC8eqzf-9jNbQ=',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '25th December, 2023',
            manufacturingLocation: 'Midnapore (E), West Bengal, India',
            supplier: 'Exide Industries Ltd.',
            supplierCountry: 'India',
            supplier1: 'Exide Cell Manufacturing Ltd.',
            supplierCountry1: 'India',
            weight: '50 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            chemistry: 'Lead Acid',
            batteryCell: 'Prismatic',
            noOfCell: 180,
            energyDensity: '0.1724 kWh/kg',
            totalEnergy: '100kWh',
            expectedLifetime: '5 years',
            ratedCapacity: '151 Ah',
            remainingLifetime: '5 years',
            virginLeadProducer: 'Beta Lead Ltd.',
            producerCountry: 'India',
            virginSulfuricProducer: 'Gamma Sulfur Ltd.',
            voltage: '450-662-742 V DC',
            tempRange: '-30°C to +60°C',
            materials: [
              {
                material: '',
                refurbisher: 'HBL Power Systems Ltd.',
                refurbisherCountry: 'India',
                recycler: 'Maruti Suzuki Toyotsu India',
                recyclerCountry: 'India',
              },
            ],
          },
          materialInfo: [
            {
              material: 'Metallic Lead (Pb)',
              traceability: '100%',
              circularity: '50%',
              physicalAmount: '35 kg',
              materialProvenance:
                '50.0 % Noida, Uttar Pradesh, India <br> 50.0 % Ludhiana, Punjab, India (Beta Lead Ltd.)',
            },
            {
              material: 'Sulfuric Acid',
              traceability: '100%',
              circularity: '0%',
              physicalAmount: '5 kg',
              materialProvenance: '100.0 % Jamnagar, Gujarat, India',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'Metallic Lead (Pb)',
              ratio: [
                {
                  subTitle: '50.0 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead (Recovered)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead (Recycled)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode + (Lead Oxide)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode - (Metallic Lead)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle: '50.0 % Ludhiana, Punjab, India (Beta Lead Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Lead Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Lead',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Metallic Lead',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode + (Lead Oxide)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode - (Metallic Lead)',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
            {
              title: 'Second Material Provenance',
              material: 'Sulfuric Acid',
              ratio: [
                {
                  subTitle: '100.0 % Jamnagar, Gujarat, India',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sulfide Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Sulfur',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sulfuric Acid',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.batteryEV]: {
          ddpData: {
            id: '7z165e4d-29lk-899u',
            created: '25th December, 2023',
            updated: '9th January, 2024',
            initiatedBy: 'Attero Recycling Pvt Ltd',
            imageUrl:
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBlVRSSjxY_fMA3yoxULmPtbeOa9cF5keMXw&s',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            refurbisher: 'Attero Recycling Pvt Ltd',
            manufacturingDate: '25th December, 2023',
            manufacturingLocation: 'Midnapore (E), West Bengal, India',
            supplier: 'Amara Raja Batteries',
            supplierCountry: 'India',
            // supplier1: 'LG Energy Solution Ltd.',
            recycler: 'Maruti Suzuki Toyotsu India',
            supplierCountry1: 'China',
            weight: '418 kg',
            volume: '0.025 m³',
            dimensions: '1500mm x 700mm x 6mm (LxBxH)',
            chemistry: 'NCM-M50',
            batteryCell: 'Cylindrical',
            noOfCell: '4,416',
            energyDensity: '0.1622 kWh/kg',
            totalEnergy: '78.05 kWh',
            expectedLifetime: '1,200 cycles',
            ratedCapacity: '219 Ah',
            remainingLifetime: '1,195 cycles',
            virginCobaltProducer: 'KRAJ Enterprises',
            producerCountry: 'India',
            voltage: '357 V DC',
            tempRange: '-30°C to +60°C',
            materials: [
              {
                material: '',
                refurbisher: 'HBL Power Systems Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
          },
          materialInfo: [
            {
              material: 'inv_LithiumCarbonate',
              traceability: '100%',
              circularity: '0%',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
            {
              material: 'inv_Iron',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
            {
              material: 'inv_Phosphate',
              traceability: '100%',
              circularity:
                '2%  <br> (Scrap contribution to car = 0.03 kg) <br> (25 * 0.02 = 0.5)',
              physicalAmount: '44 kg',
              materialProvenance:
                '2% Noida, Uttar Pradesh, India <br> 98% Mumbai, Maharashtra, India (KRAJ Enterprises)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'inv_LithiumCarbonate',
              ratio: [
                {
                  subTitle: '2 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_BatteryEV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'job_BlackMass',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'inv_LithiumCarbonateBattery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '98 % Mumbai, Maharashtra, India (KRAJ Enterprises)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Precursor',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'CAM',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cathode',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Anode',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Cell',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Module',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Battery',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.insulatorSubAssyEngineMountLH]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549580/InsulatorSubAssyEngineMountLH_zqylxs.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.bracketFRDoorBeamFR]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549603/BracketFRDoorBeamFR_qxyj3m.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.flangeEGRPipe]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549603/FlangeEGRPipe_cw0fko.png',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.plateRadiatorSupport]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549602/PlateRadiatorSupport_whdkbn.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.bracketWiringHarnessClamp]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549603/BracketWiringHarnessClamp_skup1b.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.holderFuelPressureSensor]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549603/HolderFuelPressureSensor_hjgaku.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.lockSpareWheel]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549602/LockSpareWheel_zaxcqq.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.lidFuelFillerOpeningInner]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549603/LidFuelFillerOpeningInner1_ubjj9f.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.innerMidBracket]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761550391/image_1_jjoywb.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
        [vehicleParts.pedalBracket]: {
          ddpData: {
            id: '5p165e4c-40glk-125j',
            created: '10th Jun, 2024',
            updated: '10th Jun, 2024',
            initiatedBy: 'Satelite Forgings Pvt. Ltd.',
            imageUrl:
              'https://res.cloudinary.com/dgck0tjpb/image/upload/v1761549601/PedalBracket_wpjfxp.jpg',
            qrCode:
              'https://dnum2o6eykwnz.cloudfront.net/qr-codes/qr-code_MatNEXT_Recovery_certificate 3.png',
          },
          partInfo: {
            status: 'Original',
            manufacturingDate: '10th Jun, 2024',
            manufacturingLocation:
              'VILL:BHASKUSALA, NEAR SECTOR-7 ,PHASE-II, IMT MANESAR, Gurgaon, Haryana, India, 122015',
            supplier: 'Satelite Forgings Pvt. Ltd.',
            supplierCountry: 'India',
            volume: '200 cc',
            dimensions: '5000mm * 2000mm * 1800mm',
            weight: '1.2 kg',
            tensileStrength: '350 MPa',
            corrosionResistance: '5 years',
            impactResistance: '20 J/cm²',
            virginIronProducer: 'Aanchal Ispat Ltd.',
            producerCountry: 'India',
            refurbisher: 'Vardhman Special Steels Ltd',
            refurbisherCountry: 'India',
            recyclerCountry: 'India',
            recycler: 'Maruti Suzuki Toyotsu India',
            materials: [
              {
                material: '',
                refurbisher: 'Vardhman Special Steels Ltd.',
                refurbisherCountry: 'India',
                recycler: 'MSTI Ltd.',
                recyclerCountry: 'India',
              },
            ],
            collectionDataSource: [
              {
                serviceStation: 'Maruti Suzuki Service Center',
                address: '789, Vasant Kunj, Delhi-110070',
                googleMapsLink:
                  'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
              },
            ],
          },
          materialInfo: [
            {
              material: 'job_Steel',
              traceability: '100%',
              circularity:
                '2.6%  <br> (Scrap contribution to car = 0.03 kg) <br> (1.2 * 0.026 = 0.03)',
              physicalAmount: '1.2 kg',
              materialProvenance:
                '2.6% Noida, Uttar Pradesh, India <br> 97.4% Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
            },
          ],
          dataViewInfo: [
            {
              title: 'inv_FirstMaterialProvenance',
              material: 'job_Steel',
              ratio: [
                {
                  subTitle: '2.6 % Noida, Uttar Pradesh, India',
                  dataSource: [
                    {
                      valueChain: 'ELV',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Bale',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
                {
                  subTitle:
                    '97.4 % Amritsar, Punjab, India (Aanchal Ispat Ltd.)',
                  dataSource: [
                    {
                      valueChain: 'Mining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refining',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Refined Iron Ore',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Sponge Iron',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Steel Bar',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                    {
                      valueChain: 'Body',
                      identity: 'known',
                      materialFlow: 'traced',
                      ghgEmissions: 'estimated and certified',
                      esgData: 'estimated and certified',
                    },
                  ],
                },
              ],
            },
          ],
        },
      }
  }
}

const dummyVehicleDetails = [
  {
    id: 1,
    key: 1,
    vehicleId: '12345678-12-DF-345',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24519',
    engineNumber: 'K15BN1122119',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '10/2023',
    recycleMaterialUsed: 30,
    virginMaterialUsed: 70,
    currentState: 'READY_TO_SALES',
    dppId: '7p165e4c-40glk-528j',
  },
  {
    id: 2,
    key: 2,
    vehicleId: '12345678-12-DF-346',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24520',
    engineNumber: 'K15BN1122120',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '1/2024',
    recycleMaterialUsed: 40,
    virginMaterialUsed: 60,
    currentState: 'READY_TO_SALES',
    dppId: '6p165e4d-30jk-898m',
  },
  {
    id: 3,
    key: 3,
    vehicleId: '12345678-12-DF-347',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24521',
    engineNumber: 'K15BN1122121',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '2/2024',
    recycleMaterialUsed: 80,
    virginMaterialUsed: 20,
    currentState: 'READY_TO_SALES',
    dppId: '5q165e4d-29lk-787h',
  },
  {
    id: 4,
    key: 4,
    vehicleId: '12345678-12-DF-348',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24522',
    engineNumber: 'K15BN1122122',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '4/2024',
    recycleMaterialUsed: 30,
    virginMaterialUsed: 70,
    currentState: 'SOLD',
    dppId: '6y165e4d-29lk-909i',
  },
  {
    id: 5,
    key: 5,
    vehicleId: '12345678-12-DF-349',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24523',
    engineNumber: 'K15BN1122123',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '2/2024',
    recycleMaterialUsed: 40,
    virginMaterialUsed: 60,
    currentState: 'SOLD',
    dppId: '5q165e4d-29lk-787h',
  },
  {
    id: 6,
    key: 6,
    vehicleId: '12345678-12-DF-355',
    series: 'Fronx',
    model: 'Alpha',
    vehicleCategory: '4W (Private)',
    chassisNumber: 'MA3BNC22SLG24520',
    engineNumber: 'K15BN1122120',
    typeOfProduct: 'Vehicle',
    monthYearOfManufacture: '2/2024',
    recycleMaterialUsed: 30,
    virginMaterialUsed: 70,
    currentState: 'SOLD',
    dppId: '5q165e4d-29lk-787h',
  },
]

const provenanceTitles = [
  'inv_FirstMaterialProvenance',
  'inv_SecondMaterialProvenance',
  'inv_ThirdMaterialProvenance',
  'inv_FourthMaterialProvenance',
  'inv_FifthMaterialProvenance',
  'inv_SixthMaterialProvenance',
]

export {
  vehicleParts,
  tabKeys,
  vehicleTabList,
  vehicleSideBar,
  dummyVehicleDetails,
  countryFlagImages,
  partDataDummy,
  provenanceTitles,
}
